var $ = require('../../modules/$');
module.exports = function create(P, D){
  return $.create(P, D);
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-bootstrap/~/babel-runtime/~/core-js/library/fn/object/create.js
 ** module id = 376
 ** module chunks = 0
 **/